import "./SubscriptionPreferencesFormButton.scss";
import React from "react";
import { cl } from "@ngd-web/lv-utils/ui/classNames";

export const SubscriptionPreferencesFormButtonComponent = ({
    title,
    className = null,
    ...props
}) => (
    <button
        {...props}
        className={cl(className, "SubscriptionPreferencesFormButton")}>
        {title}
    </button>
);
